import { jsxs, jsx } from 'react/jsx-runtime';
import isEqual from 'lodash/isEqual';
import { useState, useRef } from 'react';
import { useReactFormController } from '@ninja/utilities';
import { DropdownProvider } from './common3.js';
import { DropdownInputComponent } from './common4.js';
import { DropdownMenu } from './common5.js';

const MultiSelectDropdown = (props) => {
    const { valueKey, directChange, onClearValue, options, selectAllText, getIsItemDisabled } = props;
    const reactFormControllerProps = useReactFormController(props);
    const { value, onChange } = reactFormControllerProps;
    const [checkedOptions, setCheckedOptions] = useState(props.directChange || !value ? [] : value);
    const inputRef = useRef(null);
    const isDirty = !isEqual(checkedOptions, value !== null && value !== void 0 ? value : []);
    const isAllSelected = props.directChange
        ? (value === null || value === void 0 ? void 0 : value.length) === (options === null || options === void 0 ? void 0 : options.length)
        : (checkedOptions === null || checkedOptions === void 0 ? void 0 : checkedOptions.length) === (options === null || options === void 0 ? void 0 : options.length);
    const onSelectAll = (val) => {
        const result = [];
        if (val) {
            options === null || options === void 0 ? void 0 : options.forEach((item) => {
                if (getIsItemDisabled) {
                    if (!getIsItemDisabled(item)) {
                        result.push(item[valueKey]);
                    }
                }
                else {
                    result.push(item[valueKey]);
                }
            });
        }
        if (props.directChange) {
            onChange === null || onChange === void 0 ? void 0 : onChange(result);
        }
        else {
            setCheckedOptions(result);
        }
    };
    const onOptionSelected = (option, checked) => {
        var _a, _b;
        let result = [];
        const currentValue = (_a = (props.directChange ? value : checkedOptions)) !== null && _a !== void 0 ? _a : [];
        if (checked) {
            result = [...currentValue, option[valueKey]];
        }
        else {
            result = (_b = currentValue === null || currentValue === void 0 ? void 0 : currentValue.filter((item) => item !== option[valueKey])) !== null && _b !== void 0 ? _b : [];
        }
        if (props.directChange) {
            onChange === null || onChange === void 0 ? void 0 : onChange(result);
        }
        else {
            setCheckedOptions(result);
        }
    };
    const onApplyClick = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(checkedOptions);
    };
    const onClear = () => {
        onChange([]);
        setCheckedOptions([]);
        onClearValue === null || onClearValue === void 0 ? void 0 : onClearValue();
    };
    return (jsxs(DropdownProvider, Object.assign({ dropDownType: "multiple", applyFloatingMinWidth: false, inputRef: inputRef, checkedOptions: checkedOptions, onOptionSelected: onOptionSelected, onClear: onClear }, props, reactFormControllerProps, { onApplyClick: onApplyClick, isDirty: isDirty, onFocus: () => {
            var _a;
            if (!directChange)
                setCheckedOptions(value !== null && value !== void 0 ? value : []);
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props);
        }, isAllSelected: isAllSelected, selectAllText: (selectAllText !== null && selectAllText !== void 0 ? selectAllText : isAllSelected) ? 'Unselect All' : 'Select All', onSelectAll: onSelectAll, children: [jsx(DropdownInputComponent, {}), jsx(DropdownMenu, {})] })));
};

export { MultiSelectDropdown };
